import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Deletepopup from "../../components/common/Aresure";
import Loader from "../../Loader/Loader";
import { Pencil, Plus, Trash } from "lucide-react";
import { Snackbar } from "../../utils/snackbar";
import { category, deletecategory } from "../../services/Mainservice";
import Pagination from "../../components/common/pagination";

const CategoryList = () => {
  const [loading, setloading] = useState(false);
  const [data, setData] = useState([]);
  const [addinterview, setaddinterview] = useState(false);
  const [showdelete, setshowdelete] = useState(false);
  const [id, setid] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterror] = useState("");
  const [pagination, setpagination] = useState({ currentPage: 1 });

  const navigate = useNavigate();

  useEffect(() => {
    getData("1");
  }, []);

  const getData = async (page) => {
    console.log();
    setloading(true);
    try {
      const response = await category(page);
      setData(response.data.data);
      setpagination(response.data.pagination);

      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleClose = (event, reason) => {
    setOpen(false);
  };

  // const handlePageChange = (pageNumber) => {
  //   getData(pageNumber);
  // };

  // const handlesearch = async (e) => {
  //   setsearchvalue(e.target.value);
  //   getData(1, e.target.value);
  // };

  const handledelete = async () => {
    try {
      const response = await deletecategory(id);
      getData("1");
      setshowdelete(false);
    } catch (error) {
      seterror(error.message);
      setOpen(true);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
      setshowdelete(false);
    }
  };

  const onClose = () => {
    setshowdelete(false);
    // navigate("/Room");
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">All Category List</h1>
          <div className="data_headdown">
            <h1
              className="data_add"
              onClick={() => navigate("/Add_Category")}
              style={{ cursor: "pointer" }}
            >
              <Plus /> Add Category
            </h1>

            {/* <div className="searchicon">
              <SearchIcon />
              <input
                type="search"
                placeholder="Search..."
                id="search"
                // onKeyDown={handlesearch}
              />
            </div>*/}
          </div>
        </div>
        {data ? (
          <>
            <div className="data_table_over">
              <table className="data_table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.Name}</td>

                        <td>
                          {/* <button
                      // onClick={() => navigate("/User_Details")}
                      className="data_button_view"
                    >
                      View
                    </button> */}
                          <div className="user_actionicon">
                            {" "}
                            <Pencil
                              style={{
                                color: "var(--red1)",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                navigate("/Edit_Category", {
                                  state: {
                                    item,
                                  },
                                })
                              }
                            />
                            <Trash
                              style={{
                                color: "var(--red1)",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setid(item.id);
                                setshowdelete(true);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination pagedata={pagination} onPageChange={getData} />
          </>
        ) : (
          <p className="nodata">No Category</p>
        )}

        <Deletepopup
          isOpen={showdelete}
          setisOpen={setshowdelete}
          handleDelete={handledelete}
          onClose={onClose}
        />
      </div>
      {loading && <Loader />}
      <Snackbar
        open={open}
        severity="error"
        onclose={handleClose}
        message={err}
      />
    </>
  );
};
export default CategoryList;
